module.exports = __webpack_public_path__ + "static/media/image12.42a80b53.jpg";